module.exports = __webpack_public_path__ + "static/vib_play3s-90007a7f97cea6a8638b76dd3144b748.jpg";